import { INVENTORY_MODULE } from "@/api_framework/api_config";
import { IMrpUpdateSearchFilters, IMrpUpdateSearchPostResponse } from "@/api_framework/api_modals/Inventory";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback, useState } from "react";
import AxiosCurlirize from "axios-curlirize";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useAPIUtils } from "@/app/hooks/useAPIUtils";

AxiosCurlirize(axios, () => {});
type InventoryTaxCreateAPIResponse = { status: boolean; message: string };

export const useMrpUpdateSearchAPI = () => {
  const configuration = useConfiguration();
  const dispatch = useAppDispatch();
  const { sendCurl } = useCurlLogger();
  const { captureError } = useAPIUtils();
  const [mrpUpdateSearch, setMrpUpdateSearch] = useState<any>();

  const execute = useCallback(
    async (filterParams: IMrpUpdateSearchFilters) => {
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        const response: InventoryTaxCreateAPIResponse = await axios
          .post(INVENTORY_MODULE?.MRP_UPDATE_SEARCH?.baseURL ?? "", filterParams, {
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<IMrpUpdateSearchPostResponse>) => {
            if (res.data.status === true) {
              setMrpUpdateSearch(res.data.data);
              return { status: true, message: "batch" };
            } else {
              setMrpUpdateSearch(null);
              return { status: false, message: null };
            }
          })
          .catch((e: AxiosError) => {
            sendCurl(e.config["curlCommand"]);
            captureError(e);
            setMrpUpdateSearch(null);
            return { status: false, message: null };
          });
        return response;
      } catch (e: any) {
        setMrpUpdateSearch(null);
        // toast.error("Server Error: " + e.message);
      }
    },
    [dispatch],
  );
  return { execute, mrpUpdateSearch };
};
